import React, { Component } from "react";
import Banner from "../../components/common/Banner";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import ExploreSidebar from "./components/ExploreSidebar";
import { doc, getDoc } from "firebase/firestore";
import { firestore } from "../../Config/FbConfig";

export default class ExploreChairman extends Component {
  state = {
    GCDatas: [],
    Loading: true,
  };

  //Load Data Here
  async componentDidMount() {
    //Get GC Member Data
    const docRef_3 = doc(firestore, "Other", "GCMembers");
    const docSnap_3 = await getDoc(docRef_3);
    var Data_3 = [];
    if (docSnap_3.exists()) {
      Object.entries(docSnap_3.data()).forEach(([key, value]) => {
        Data_3.push(
          Object.assign(
            {
              Id: key,
              Priority: value.Priority != undefined ? value.Priority : "999",
            },
            value
          )
        );
      });

      Data_3.length === 0
        ? this.setState({ GCDatas: "NO_999", Loading: false })
        : this.setState({
            GCDatas: Data_3.sort(function (a, b) {
              return a.Priority - b.Priority;
            }),
            Loading: false,
          });
    }
  }

  render() {
    return (
      <div>
        {/* Header */}
        <Header />

        {/* Banner */}
        <Banner title="Explore BIT" image="banners/banner-explore.jpg" />

        {/* Content */}
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-9 content-area order-lg-2">
                <div className="section-title with-desc text-left clearfix">
                  <div className="title-header">
                    <h3 className="title">Chairman</h3>
                  </div>
                </div>
                <div className="ttm-service-single-content-area">
                  <section className="ttm-row team-details-section clearfix">
                    <div className="container-xl">
                      <div className="row">
                        <div className="col-lg-6" style={{ margin: "auto" }}>
                          <div className="ttm-featured-wrapper">
                            <div className="featured-thumbnail text-center">
                              <img
                                style={{
                                  width: "300px",
                                  height: "300px",
                                  borderRadius: "12px",
                                }}
                                src={
                                  process.env.PUBLIC_URL +
                                  `/assets/images/explore/chairman.jpeg`
                                }
                                alt=""
                                className="img-fluid"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6" style={{ margin: "auto" }}>
                          <h4 style={{ color: "#b22222" }}>
                            Shri. Ashok S.D. Jayaram
                          </h4>
                          <h6
                            style={{
                              margin: "0.5rem 0 0.5rem 0",
                            }}
                          >
                            Chairman, Governing Council
                          </h6>
                          <h6 style={{ marginBottom: "1.5rem" }}>
                            Bangalore Institute of Technology
                          </h6>
                        </div>
                        <div
                          className="col-lg-12 justify"
                          style={{ margin: "auto" }}
                        >
                          <div
                            className="ttm-team-member-content shadow-box res-991-mt-30"
                            style={{
                              padding: "2rem",
                              background: "#fff",
                              borderRadius: "10px",
                            }}
                          >
                            <hr />
                            <h5 style={{ color: "#b22222" }}>
                              Educational & Family Background
                            </h5>
                            <p
                              style={{
                                marginBottom: "1rem",
                                marginTop: "1rem",
                              }}
                            >
                              Sri. Ashok S D Jayaram is the son of late Sri. S D
                              Jayaram, a respected political statesman, former
                              Member of the Legislative Assembly, Mandya and was
                              a Cabinet Minister in the Government of Karnataka.
                              Rooted in a legacy of public service and
                              leadership, he began his academic journey with
                              primary schooling in Mandya and later pursued high
                              school and intermediate education at the esteemed
                              Sri Ramakrishna Vidya Shala, Mysore, emphasizing
                              holistic personality development.
                            </p>
                            <p>
                              Driven by a deep interest in technology and
                              innovation, he earned his Bachelor of Engineering
                              degree in Information Science & Engineering from
                              Sri Jayachamarajendra College of Engineering
                              (SJCE), Mysuru. He gained valuable industry
                              experience working with leading multinational
                              corporations including Tata Consultancy Services
                              (TCS), Telecom gaint Huawei.
                            </p>
                            <p
                              style={{
                                marginBottom: "1rem",
                                marginTop: "1rem",
                              }}
                            >
                              In pursuit of higher education and global
                              exposure, he completed his Master of Business
                              Administration (MBA) from the University of North
                              Carolina at Chapel Hill, USA—an experience that
                              nurtured his commitment to societal development
                              and inclusive growth. Inspired by a vision to
                              serve, he returned to India in 2011 and actively
                              engaged in developmental initiatives, laying the
                              foundation for his impactful journey in the social
                              and education sectors.
                            </p>
                            <h5 style={{ color: "#b22222" }}>
                              Social Commitment, Outreach, and Political
                              Engagement
                            </h5>
                            <p
                              style={{
                                marginBottom: "1rem",
                                marginTop: "1rem",
                              }}
                            >
                              Sri. Ashok S D Jayaram has been consistently
                              working for over a decade and a half in the areas
                              of rural development, public health, and education
                              for all. As the driving force behind the S D
                              Jayaram Integrated Rural Development Trust and
                              Belaku Eye Foundation, he has pioneered numerous
                              grassroots programs aimed at uplifting
                              under-served communities. Through Belaku Eye
                              Hospital, he has been instrumental in providing
                              vision care to over 10,000 rural patients,
                              reinforcing his commitment to accessible and
                              compassionate healthcare.
                            </p>
                            <p
                              style={{
                                marginBottom: "1rem",
                              }}
                            >
                              He is actively involved in the political sphere
                              with core objectives of serving communities,
                              connecting with people, fulfilling their
                              aspirations and foster transparent,
                              development-oriented governance. His leadership
                              has been recognized through his election as a
                              Director of the Rajya Vokkaligara Sangha (RVS) for
                              a five-year term from Mandya District. Currently,
                              as an Executive Committee Member of RVS, he holds
                              the distinguished responsibility of Chairman of
                              the Governing Council at Bangalore Institute of
                              Technology (BIT).
                            </p>
                            <h5 style={{ color: "#b22222" }}>
                              {" "}
                              Vision for Bangalore Institute of Technology
                            </h5>
                            <p
                              style={{
                                marginBottom: "1rem",
                                marginTop: "1rem",
                              }}
                            >
                              As Chairman of the Governing Council at Bangalore
                              Institute of Technology, Sri. Ashok S.D. Jayaram
                              is driving a strategic vision to establish it as a
                              Karnataka's premier engineering institution
                              through ground breaking initiatives:
                            </p>
                            <ul
                              style={{
                                textAlign: "left",
                                marginLeft: "1.5rem",
                                listStyleType: "disc",
                              }}
                            >
                              <li
                                style={{
                                  marginBottom: "1rem",
                                  marginTop: "1rem",
                                }}
                                className="justify"
                              >
                                <strong>Infrastructure Push : </strong>{" "}
                                Spearheading the construction of nearly 2.5 lakh
                                square feet of new state-of-the-art academic and
                                innovation space.
                              </li>
                              <li className="justify">
                                <strong>
                                  Innovation & Entrepreneurship Center :
                                </strong>{" "}
                                Establishing a robust ecosystem to support
                                student start-ups, incubate ideas, fostering a
                                culture of innovation and bridge academic
                                learning with real-world problem-solving.
                              </li>
                              <li
                                style={{
                                  marginBottom: "1rem",
                                  marginTop: "1rem",
                                }}
                                className="justify"
                              >
                                <strong>
                                  Experiential Learning & Industry Integration :
                                </strong>{" "}
                                Emphasizing hands-on, real-world learning
                                experiences that align with industry needs.
                                Fostering deeper industrial collaboration via
                                internships, live projects, and
                                industry-designed curricula to ensure graduate
                                readiness.
                              </li>
                              <li className="justify">
                                <strong>
                                  Global Academic Collaborations :{" "}
                                </strong>{" "}
                                Establishing strategic collaborations with
                                globally renowned universities to foster global
                                exposure to students and faculty through
                                exchange programs, collaborative research, and
                                joint academic initiatives—strengthening BIT’s
                                position in the global academic community.
                              </li>
                            </ul>
                            <p
                              style={{
                                marginBottom: "1rem",
                                marginTop: "1rem",
                              }}
                            >
                              Under his visionary, dynamic leadership, BIT is
                              strategically positioned to achieve unprecedented
                              excellence in technical education, innovation, and
                              societal impact.
                            </p>
                          </div>
                        </div>

                        <div className="section-title with-desc text-left clearfix paddingtop-1">
                          <div
                            className="title-header paddingtop-2"
                            style={{ borderTopColor: "red" }}
                          >
                            <h4 className="title">Governing Council Members</h4>
                          </div>
                        </div>
                        <div
                          className="row ttm-service-description"
                          style={{ textAlign: "center" }}
                        >
                          {this.state.GCDatas.map((data, i) => (
                            <div
                              className="col-md-4 paddingtop-2"
                              style={{ textAlign: "center" }}
                            >
                              <img
                                className="img-fluid"
                                src={data.Image}
                                alt="error"
                              />
                              <h6 className="paddingtop-1">{data.Name}</h6>
                              <small>{data.Designation}</small>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
              <div className="col-lg-3 widget-area">
                <ExploreSidebar />
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    );
  }
}
